import { Button, Divider, Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconLogin2 } from '@tabler/icons-react';
import AuthenticationForm from '@/app/components/shell/navbar/authentication/AuthenticationForm';
import { useTranslation } from '@/i18n/client';
import classes from './AuthModal.module.css';

export function AuthModal() {
  const [opened, { open, close }] = useDisclosure(false);
  const { t } = useTranslation('auth');
  return (
    <>
      <Modal opened={opened} onClose={close} centered withCloseButton={false} p={0}>
        <AuthenticationForm />
        <Divider my='md' />
        <Button
          style={{ float: 'right' }}
          mb='md'
          onClick={close}
          variant='filled'
          color='rgb(20, 20, 50)'
        >
          {t('close')}
        </Button>
      </Modal>

      <Button
        variant='subtle'
        onClick={open}
        rightSection={<IconLogin2 size={22} />}
        mr={10}
        className={classes.button}
      >
        {t('login').toUpperCase()}
      </Button>
    </>
  );
}

export default AuthModal;
